<template>
    <div v-show="active">
        <div class="category d-flex d-flex-row flex-nowrap">
            <div class="category-item verticalAlignMiddle"><h2>Hintergrundbild</h2></div>
            <div class="edit-item verticalAlignMiddle textAlignRight"><a href="" v-on:click.stop.prevent="active = !active"><i class="fa fa-pencil"></i></a></div>
        </div>
        <hr style="margin-top:5px;"/>
        <div v-if="active" class="category-content">
            <file-upload
                extensions="gif,jpg,jpeg,png,webp"
                accept="image/png,image/gif,image/jpeg,image/webp"
                name="image"
                style="margin-bottom:20px"
                class="btn btn-white teaserButton width100"
                post-action="/upload/image/banner"
                :drop="drop"
                :multiple="multiple"
                v-model="files"
                @input-filter="inputFilter"
                @input-file="inputFile"
                ref="upload">
                Bild auswählen
            </file-upload>
            <div class="clearfix">
            <div v-for="file in files" :key="file.id" :class="['oldFullImageContainer',  hasError?'error':'temp', 'dropzone', {'active': $refs.upload && $refs.upload.dropActive}]">
                <div class="oldFullImageContainerContent textAlignCenter verticalAlignMiddle">
                    <img class="width100" ref="editImage" v-if="file.thumb" v-on:cropmove="crop" :src="file.thumb" />
                </div>
            </div><!-- smallImageContainer -->
            </div>
            <div v-if="files.length == 0" :class="['textAlignCenter', 'clearfix', 'oldFullImageContainer', 'dropzone', {'active': $refs.upload && $refs.upload.dropActive}]">
                <div class="oldFullImageContainerContent">
                    <div class="textAlignCenter verticalAlignMiddle">
                        <div>
                            <i class="fa fa-picture-o fa-2x"></i>
                        </div>
                        <div>
                            Dein Bild
                        </div>
                    </div>
                </div>
            </div><!-- smallImageContainer -->
            <div v-if="hasError" class="errorBox">Der ausgewählte Bildausschnitt ist zu groß, wähle einen kleineren Ausschnitt oder verwende ein anderes Bild.</div>
            <div class="textAlignRight buttonBlockContainerRight">
                <button type="button" v-on:click="cancel" class="btn btn-white teaserButton width100">Abbrechen</button>
                <button type="button" v-on:click="save" class="btn btn-white teaserButton width100" :disabled="uploadHasErrors()">Speichern</button>
            </div>
        </div>
        <!-- Modal -->
        <div ref="modalDialog" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Möchten Sie das Profilbild wirklich löschen?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Nein</button>
                    <button @click="finishRemove" type="button" class="btn btn-primary" data-dismiss="modal">Ja</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Modernizr from 'modernizr';
    import FileUpload from 'vue-upload-component'
    import Cropper from 'cropperjs'
    import Vue from 'vue';
	export default {
		name: 'profileBannerEditor',
		props: {
            profileId: String,
            image: String
        },
        data: function() {
        	return {
                hasAvatar: false,
                active: false,
                inSave: false,
                hasError: false,
                files: [],
                multiple: false,
                directory: false,
                drop: true,
                dropDirectory: false,
                thread: 3,
                edit: false,
                minSize: 1024,
                size: 4 * 1024 * 1024,
                uploadAuto: false,
                name: 'image',
                edit: false,
                cropper: false,
                croppedUrl: '',
                currentImage: null
        	}
        },
        created: function() {
            var self = this;
            this.currentImage = this.image;
            if (this.image !== '/images/header_static/profile_background_final.jpg') {
                this.hasAvatar = true;
            }
            this.$bus.$on('activateProfileBannerEditor', ($event) => {
                self.active = true;
                self.$scrollTo(self.$el);
            });
        },
          watch: {
                edit(value) {
                    if (value) {
                        this.$nextTick(function () {
                        if (!this.$refs.editImage || this.$refs.editImage.length == 0) {
                            return
                        }
                        let cropper = new Cropper(this.$refs.editImage[0], {
                            aspectRatio: 1200 / 480,
                            viewMode: 1,
                            autoCropArea: 1,
                            preview: document.getElementById('demo')
//                            preview: this.$refs.previewImage2
                        })
                        this.cropper = cropper
                        })
                    } else {
                        console.log('edit is false');
                        if (this.cropper) {
                        this.cropper.destroy()
                        this.cropper = false
                        }
                    }
                },
                active(value) {
                    if (value) {
                        if (!this.edit && this.$refs.editImage && this.$refs.editImage.length > 0) {
                            this.$nextTick(function() {
                                this.edit = true;
                            });
                        }
                    } else {
                        if (this.edit) {
                            this.$nextTick(function() {
                                this.edit = false;
                            });
                        }
                    }
                    this.$bus.$emit('editBanner', value);
                }
            },
        methods: {
            uploadHasErrors: function() {
                if (this.isSave) {
                    return true;
                }
                if (this.files.length == 0) {
                    return true;
                }
                if (this.hasError) {
                    return true;
                }
                return false;
            },
            save: function() {
                if (this.inSave) {
                    return;
                }
                if (this.uploadHasErrors()) {
                    return;
                }
                this.inSave = true;
                let oldFile = this.files[0];
                let croppedCanvas = this.cropper.getCroppedCanvas(); 
                let dataURI;
                if (croppedCanvas.width > 2400) {
                    let scaleFactor = 2400 / croppedCanvas.width;
                    let newCanvas = document.createElement('canvas');
                    newCanvas.width = 2400;
                    newCanvas.height = 960;
                    let context = newCanvas.getContext( '2d' );
                    context.scale(scaleFactor, scaleFactor);
                    context.drawImage(croppedCanvas, 0, 0);
                    dataURI = newCanvas.toDataURL(oldFile.type);
                } else {
                    dataURI = croppedCanvas.toDataURL(oldFile.type);
                }

                let blob = this.dataURItoBlob(dataURI);
                this.$refs.upload.update(oldFile.id, {
                    file: blob,
                    type: blob.type,
                    size: blob.size,
                    active: true,
                });
                this.edit = false
            },
            dataURItoBlob: function(dataURI) {
                var byteString = atob(dataURI.split(',')[1]);
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var arrayBuffer = new ArrayBuffer(byteString.length);
                var _ia = new Uint8Array(arrayBuffer);
                for (var i = 0; i < byteString.length; i++) {
                    _ia[i] = byteString.charCodeAt(i);
                }
                var dataView = new DataView(arrayBuffer);
                var blob = new Blob([dataView], { type: mimeString });
                return blob;
            },
            remove: function() {
                jQuery(this.$refs.modalDialog).modal('show');
            },
            finishRemove: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/profile/' + self.profileId + '/banner',
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        //clean up
                        self.$nextTick(function() {
                            self.hasAvatar = false;
                            self.currentImage = data.url;
                            if (self.files.length > 0) {
                                self.$refs.upload.remove(self.files[0]);
                            }
                            self.active = false;
                            self.$bus.$emit('changedBanner', data.url);
                            self.$bus.$emit('changedCompletion');
                        });
                    },
                    error: function() {alert("error");}
                });
            },
            finishedUpload: function(resourceId) {
                var self = this;
                jQuery.ajax ({
                    url: '/profile/' + self.profileId + '/banner/' + resourceId,
                    type: 'POST',
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        //clean up
                        self.$nextTick(function() {
                            self.inSave = false;
                            self.hasAvatar = true;
                            self.currentImage = data.url;
                            self.$refs.upload.remove(self.files[0]);
                            self.active = false;
                            self.$bus.$emit('changedBanner', data.url);
                            self.$bus.$emit('changedCompletion');
                        });
                    },
                    error: function() {
                        self.inSave = false;
                        alert("error");
                    }
                });
            },
            cancel: function() {
                this.active = false;
            },
            crop: function($event) {
                if (this.files[0].error) {
                    this.$refs.upload.update(this.files[0], {error: null});
                    this.hasError = false;
                }
            },
            getCurrentImage: function() {
                if (this.edit && this.cropper && this.cropper.getCroppedCanvas() !== null) {
                    return this.cropper.getCroppedCanvas().toDataURL();
                }
                if (this.files.length > 0) {
                    return this.files[0].thumb;
                }
                return this.currentImage;
            },
            inputFile(newFile, oldFile, prevent) {
                if (newFile && oldFile) {
                    // update
                    if (newFile.active && !oldFile.active) {
                    // beforeSend
                        // min size
                        if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                            this.$refs.upload.update(newFile, { error: 'size' });
                            this.hasError = true;
                        }
                        // max size
                        if (newFile.size >= 0 && this.size > 0 && newFile.size > this.size) {
                            this.$refs.upload.update(newFile, { error: 'size' })
                            this.hasError = true;
                        }
                    }
                    if (newFile.progress !== oldFile.progress) {
                    // progress
                    }
                    if (newFile.error && !oldFile.error) {
                    // error
                        this.inSave = false;
                    }
                    if (newFile.success && !oldFile.success) {
                    // success
                        if (newFile.response && newFile.response.id) {
                            this.finishedUpload(newFile.response.id);
                        }
                    }
                    if (!newFile.active) {
                        this.edit = true;
                    }
                }
                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        //TODO: support deletion of unreferenced s3 content
                    // $.ajax({
                    //   type: 'DELETE',
                    //   url: '/upload/delete?id=' + oldFile.response.id,
                    // })
                    }
                    this.edit = false;
                    this.hasError = false;
                }
                if (newFile && !oldFile) {
                    // insert
                    this.$nextTick(function () {
                        this.edit = true
                    })
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent()
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    // Create a blob field
                    newFile.blob = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    // Thumbnails
                    newFile.thumb = ''
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob;
                    }
                }
            }
        },
        components: { FileUpload }
	}
</script>


// WEBPACK FOOTER //
// ProfileBannerEditor.vue?73f4efad